export default "__VITE_ASSET__KxidmhqA__"